import { currentAppBrand } from '@b2ag/app-brands'

/* ------- ROUTES ------- */

import { coreRoutes } from './core'
import { articlesRoutes } from './articles'
import { authRoutes } from './auth'
import { accountRoutes } from './my-account'
import { cartRoutes } from './cart'
import { checkoutRoutes, orderConfirmationRoute } from './checkout'
import { landingMainRoutes } from './landing'
import { legalsMainRoutes, legalsTechRoutes } from './legals'
import { membershipRoutes } from './membership'
import { listsRoutes } from './shopping-list'
import { signInRoutes } from './signup'
import { farmiAppApproRoutes } from './farmi-app-appro'
import { portalRoutes } from './portal'
import { ordersRoutes } from './orders'
import { smagRoutes } from './smag'
import { getAliasForRouter } from '@b2ag/utils/src/i18n-routing'

/* ------- PARENT - LAYOUT ------- */

const injectAliasForRoute = (route) => ({ ...route, alias: getAliasForRouter(currentAppBrand, route.path) })

export default [
  ...authRoutes,
  ...signInRoutes.map(injectAliasForRoute),
  ...checkoutRoutes.map(injectAliasForRoute),
  ...smagRoutes.map(injectAliasForRoute),
  ...legalsTechRoutes.map(injectAliasForRoute),

  ...articlesRoutes.map(injectAliasForRoute),
  ...cartRoutes.map(injectAliasForRoute),
  ...legalsMainRoutes.map(injectAliasForRoute),
  ...accountRoutes.map(injectAliasForRoute),
  ...landingMainRoutes.map(injectAliasForRoute),
  ...farmiAppApproRoutes.map(injectAliasForRoute),
  ...membershipRoutes.map(injectAliasForRoute),
  ...listsRoutes.map(injectAliasForRoute),
  ...ordersRoutes.map(injectAliasForRoute),
  ...orderConfirmationRoute.map(injectAliasForRoute),
  ...coreRoutes.map(injectAliasForRoute),
  ...portalRoutes.map(injectAliasForRoute), // ne pas le déplacer d'ici, sinon ça va écraser la route Home standard
]
